import {Component, Input} from '@angular/core';
import {ZoomFooterComponent} from '../zoom-footer/zoom-footer.component';

@Component({
    selector: 'zoom-footer-raet',
    templateUrl: './zoom-footer-raet.component.html',
    styleUrls: ['./zoom-footer-raet.component.scss']
})
export class ZoomFooterRaetComponent extends ZoomFooterComponent {

    @Input() PolicyLink: string;
    @Input() raetId: string;

    isValid() {
        super.isValid();
        if (!this.PolicyLink) {
            console.log('There is no link in this component');
        }
    }
}
